module.exports = __webpack_public_path__ + "img/instantinterview.672fc4ec.png";